
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import mochawesome from '../../assets/mochawesome.json'

export default {
  name: 'Detail',

  data: function () {
    return {
      timestampData: null,
      notificationData: null,
      checkToggle: true,
      dashText: {},
      reportTotDuration: null,
      reportTotSuites: null,
      reportTotTests: null,
      reportTotPassed: null,
      reportTotFailed: null,
      reportTotSkipped: null,
      reportTotPending: null,
      reportSuites: null
    }
  },
  computed: {},

  methods: {
    /**
     * Get data from mocha report
     * @param {*} report
     */
    getMochaReportData: function (report) {
      if (report.hasOwnProperty('stats') && report.hasOwnProperty('suites')) {
        this.reportTotDuration = this.millisToMinutesAndSeconds(report.stats.duration)
        this.reportTotSuites = report.stats.suites ? report.stats.suites : 0
        this.reportTotTests = report.stats.tests ? report.stats.tests : 0
        this.reportTotPassed = report.stats.passes ? report.stats.passes : 0
        this.reportTotFailed = report.stats.failures ? report.stats.failures : 0
        this.reportTotSkipped = report.stats.skipped ? report.stats.skipped : 0
        this.reportTotPending = report.stats.pending ? report.stats.pending : 0
        this.reportSuites = report.suites.suites ? report.suites.suites : []
        this.reportSuites = this.setSuiteTotal(this.reportSuites)
        this.timestampData = new Date(report.stats.end).toString()
      } else {
        console.error('report data not found')
      }
    },

    /**
     * Convert millis input to string format output.
     * @param {int} millis
     */
    millisToMinutesAndSeconds: function (millis) {
      if (millis < 1000) {
        return millis + 'ms'
      }
      let seconds = ((millis % 60000) / 1000).toFixed(0)
      if (millis < 60000) {
        return seconds + 's'
      }
      let minutes = Math.floor(millis / 60000)
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds + 'm'
    },

    /**
     * Count how many test cases are passed/failured/skipped/pending for each suite
     * and create totals property inside suite object.
     * @param {Array} arrSuites
     */
    setSuiteTotal: function (arrSuites) {
      arrSuites.forEach(function (rootSuite) {
        rootSuite.customPasses = 0
        rootSuite.customFailures = 0
        rootSuite.customSkipped = 0
        rootSuite.customPending = 1
        /*
          rootSuite.resultToRender = 0 => green (90-100%)
          rootSuite.resultToRender = 1 => red (70-90%)
          rootSuite.resultToRender = 2 => yella (<70%)
        */
        rootSuite.resultToRender = 1

        if (rootSuite.suites && rootSuite.suites.length > 0) {
          rootSuite.suites.forEach(function (firstLevelSuite) {
            if (firstLevelSuite.suites && firstLevelSuite.suites.length > 0) {
              firstLevelSuite.suites.forEach(function (testCaseSuite) {
                if (testCaseSuite.tests && testCaseSuite.tests.length > 0) {
                  rootSuite.customPasses = rootSuite.customPasses + testCaseSuite.passes.length
                  rootSuite.customFailures = rootSuite.customFailures + testCaseSuite.failures.length
                  rootSuite.customSkipped = rootSuite.customSkipped + testCaseSuite.skipped.length
                  rootSuite.customPending = rootSuite.customPending + testCaseSuite.pending.length
                }
              })
            } else if (firstLevelSuite.tests && firstLevelSuite.tests.length === 0) {
              rootSuite.customPasses = firstLevelSuite.passes.length
              rootSuite.customFailures = firstLevelSuite.failures.length
              rootSuite.customSkipped = firstLevelSuite.skipped.length
              rootSuite.customPending = firstLevelSuite.pending.length
            }
          })
        } else if (rootSuite.tests && rootSuite.tests.length === 0) {
          rootSuite.customPasses = rootSuite.passes.length
          rootSuite.customFailures = rootSuite.failures.length
          rootSuite.customSkipped = rootSuite.skipped.length
          rootSuite.customPending = rootSuite.pending.length
        }
        let totalTests = parseInt(rootSuite.customPasses) + parseInt(rootSuite.customFailures) + parseInt(rootSuite.customSkipped) + parseInt(rootSuite.customPending)
        if (totalTests > 0) {
          let perc = (rootSuite.customPasses / totalTests) * 100
          if ((perc > 90 && perc < 100) || (perc === 90) || (perc === 100)) {
            rootSuite.resultToRender = 0
          } else if ((perc > 70 && perc < 90) || (perc === 70)) {
            rootSuite.resultToRender = 2
          }
        }
      })
      return arrSuites
    },

    goToAPIDetail: function () {
      this.$router.push('detail')
    }
  },

  mounted: function () {
    this.dashText = this.$stringFile['en'].dashboard
    // this.dashText = this.$stringFile[[$store.getters.getUserHomeLanguage]].dashboard
  },

  created: function () {
    console.log('home')

    // Listen to $emit event
    this.$root.$on('headerToggle', (isToggle) => {
      this.checkToggle = isToggle
    })

    // TODO: mok data to remove
    this.notificationData = {
      text: 'Lorem ipsum dolor sit amet, consectetur adipisci elit, sed eiusmod tempor incidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.'
    }

    console.log('testJSON', mochawesome) // TODO: get report from remote API
    this.getMochaReportData(mochawesome)
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/detail.js